// extracted by mini-css-extract-plugin
export default {"PlainFeature":"wf_a bhr_b"};